/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav.
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.

  Convenciones propias:
  - `type: "title"` a nivel raíz agrupa los módulos en secciones del menú
    (Gestión Comercial, Inventario y Logística, etc.). El Sidenav oculta la
    sección si el rol no ve ningún módulo dentro de ella.
  - `type: "subheader"` dentro de un `collapse` pinta una etiqueta pequeña
    (p.ej. "Reportes") que separa las pantallas operativas de los informes.
  - Las entradas sin `type` son rutas ocultas de compatibilidad: mantienen
    vivas las URLs viejas pero no salen en el menú.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Entrar from "layouts/login";
import InformeMotores from "modules/motores/informemotores";
import RegistroChasis from "modules/motores/registrochasis";
import Conteos from "modules/conteos/conteos";
import ConteoActivo from "modules/conteos/conteoactivo";
import ReporteConteos from "modules/conteos/reporteconteos";
import MarcasModelos from "modules/marcasmodelos/marcasmodelos";
import Embarques from "modules/importaciones/embarques";
import Cobrosincautosfechas from "modules/motores/cobrosincautosfechas";
import SolicitudesCredito from "modules/facturacion/solicitudescredito";
import Cotizaciones from "modules/cotizaciones/cotizaciones";
import Ventas from "modules/facturacion/ventas";
import Iniciales from "modules/facturacion/iniciales";
import ConsultaSolicitudes from "modules/facturacion/consultasolicitudes";
import ModificacionPrestamos from "modules/facturacion/modificacionprestamos";
import Refinanciamientos from "modules/facturacion/refinanciamientos";
import PrestamosPersonales from "modules/facturacion/prestamospersonales";
import ConfiguracionHub from "modules/configuracion/configuracionhub";
import Incautos from "modules/incautos/incautos";
import PagosIncautadoresUnificado from "modules/incautos/pagosincautadoresunificado";
import SolicitudesIncauto from "modules/incautos/solicitudesincauto";
import ReporteCrediticio from "modules/prestamos/reportecrediticio";
import EstadosDeCuenta from "modules/prestamos/estadosdecuenta";
import Documentos from "modules/documentacion/documentos";
import Expediente from "modules/prestamos/expediente";
import Clientes from "modules/clientes/clientes";
import GestionCobros from "modules/prestamos/gestioncobros";
import PrestamosUnificado from "modules/prestamos/prestamosunificado";
import RecibirMatriculaDgii from "modules/matriculas/recibirmatriculadgii";
import Solicitudes from "modules/matriculas/solicitudes";
import PedidosMatricula from "modules/matriculas/pedidos";
import MatriculasCobros from "modules/matriculas/matriculascobros";
import Traspasos from "modules/matriculas/traspasos";
import VentasGeneralesUnificado from "modules/ventasgenerales/ventasgeneralesunificado";
import PagosVentasUnificado from "modules/ventasgenerales/pagosventasunificado";
import XmayorFacturas from "modules/ventasxmayor/xmayorfacturas";
import XmayorCobros from "modules/ventasxmayor/xmayorcobros";
import XmayorClientes from "modules/ventasxmayor/xmayorclientes";
import XmayorConsignaciones from "modules/ventasxmayor/xmayorconsignaciones";
import CxpFacturas from "modules/cuentasxpagar/cxpfacturas";
import CxpPagos from "modules/cuentasxpagar/cxppagos";
import CxpSuplidores from "modules/cuentasxpagar/cxpsuplidores";
import Cuadres from "modules/facturacion/cuadres";
import Auditoriarecibos from "modules/pagos/auditoriarecibos";
import Pagos from "modules/pagos/pagos";
import Interescobradoperiodo from "modules/pagos/interescobradoperiodo";
import Proyectadocobros from "modules/pagos/proyectadocobros";
import Pagosantcuota from "modules/pagos/pagosantcuota";
import ReporteMorosidad from "modules/prestamos/reportemorosidad";
import ReporteEquifax from "modules/prestamos/reporteequifax";
import ReporteAntiguedadSaldo from "modules/prestamos/antiguedaddesaldo";
import ReporteDescuentos from "modules/prestamos/informedescuentos";
import CalculadoraPrestamos from "modules/prestamos/calculadoraprestamos";
import Transferenciaschasis from "modules/motores/transferenciachasis";
import Transferenciadocumentos from "modules/motores/transferenciadocumentos";
import HistorialChasis from "modules/motores/historialchasis";
import ImportacionDatos from "modules/importacion/importacionDatos";
import ImportarXmayor from "modules/ventasxmayor/importarxmayor";
import ImportarConducesXmayor from "modules/ventasxmayor/importarconducesxmayor";
import ImportarVentasContado from "modules/importacion/importarventascontado";
import DataOrbit from "modules/dataorbit";
import Bitacora from "modules/herramientas/bitacora";
import Informegastos from "modules/gastos/informegastos";
import OrdenesTaller from "modules/taller/ordenestaller";
import Garantias from "modules/garantias/garantias";
import Consignaciones from "modules/motores/Consignaciones/consignaciones";

// @mui icons
import Icon from "@mui/material/Icon";
import DashboardPantalla from "layouts/dashboard/pantallacompleta";

const routes = [
  {
    type: "collapse",
    name: "Inicio",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  // Ruta oculta: dashboard a pantalla completa (botón "Pantalla Completa"
  // del Inicio, solo AdmG). Mantiene la URL histórica con su typo.
  {
    name: "Dashboard pantalla completa",
    key: "dashboard-pantalla",
    route: "/inventario/dashaboard",
    component: <DashboardPantalla />,
  },

  { type: "title", title: "Gestión Comercial", key: "seccion-gestion-comercial" },

  {
    type: "collapse",
    name: "Facturación",
    key: "facturacion",
    programa: "facturacion",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/facturacion",
    component: "",
    collapse: [
      // "Motores Facturados" (viejo) y "Chasis Incautados" se quitaron del
      // menú; el informe de facturados vive embebido en la pantalla Ventas.
      // Modificación Préstamos, Refinanciamientos y Préstamos Personales se
      // movieron al módulo Préstamos (Facturación = vender; Préstamos =
      // administrar lo vendido); sus URLs viejas viven allá como legacy.
      {
        type: "collapse",
        name: "Solicitudes de Crédito",
        key: "solicitudescredito",
        route: "/facturacion/solicitudescredito",
        component: <SolicitudesCredito />,
      },
      {
        type: "collapse",
        name: "Ventas",
        key: "ares2010",
        // El listado embebido es el informe de motores facturados: quien solo
        // tiene ese programa también accede (verá el listado sin las tarjetas).
        keys: ["ares2010", "ares2015", "informemotoresfacturados"],
        route: "/facturacion/ventas",
        component: <Ventas />,
      },
      // Rutas ocultas de compatibilidad: los enlaces viejos de venta a crédito
      // y al contado llevan a la pantalla unificada (sin `type` no salen en el menú).
      {
        name: "Ventas (crédito)",
        key: "ares2010-legacy",
        route: "/facturacion/ventaproductos",
        component: <Ventas />,
      },
      {
        name: "Ventas (contado)",
        key: "ares2015-legacy",
        route: "/facturacion/ventacontado",
        component: <Ventas />,
      },
      {
        name: "Ventas (informe nuevo)",
        key: "informemotoresfacturados-legacy",
        route: "/facturacion/informemotoresfacturados-nuevo",
        component: <Ventas />,
      },
      {
        name: "Ventas (informe viejo)",
        key: "informemotoresfacturados-viejo-legacy",
        route: "/facturacion/informemotoresfacturados",
        component: <Ventas />,
      },
      {
        type: "collapse",
        name: "Iniciales",
        key: "ares4020",
        keys: ["ares4020", "ares4025", "ares4035"],
        route: "/facturacion/iniciales",
        component: <Iniciales />,
      },
      // Rutas ocultas de compatibilidad: los enlaces viejos de cobro/cancelar
      // inicial llevan a la pantalla unificada (sin `type` no salen en el menú).
      {
        name: "Iniciales (cobro)",
        key: "ares4020-legacy",
        route: "/facturacion/cobroinicial",
        component: <Iniciales />,
      },
      {
        name: "Iniciales (cancelar)",
        key: "ares4025-legacy",
        route: "/facturacion/cancelarinicial",
        component: <Iniciales />,
      },
      {
        type: "collapse",
        name: "Consulta de Solicitudes",
        key: "ares2030",
        route: "/facturacion/consultasolicitudes",
        component: <ConsultaSolicitudes />,
      },
      {
        type: "collapse",
        name: "Cuadre de Caja",
        key: "ares7070",
        keys: ["ares7070", "cuadrecaja", "ares7075"],
        route: "/facturacion/cuadres",
        component: <Cuadres />,
      },
      // Rutas ocultas de compatibilidad: las URLs viejas de los tres cuadres
      // llevan a la pantalla unificada (sin `type` no salen en el menú).
      {
        name: "Cuadre (completo)",
        key: "ares7070-legacy",
        route: "/facturacion/cuadrecajacompleto",
        component: <Cuadres />,
      },
      {
        name: "Cuadre (desglose)",
        key: "cuadrecaja-legacy",
        route: "/facturacion/cuadrecaja",
        component: <Cuadres />,
      },
      {
        name: "Cuadre (resumen)",
        key: "ares7075-legacy",
        route: "/facturacion/cuadrecajaresumen",
        component: <Cuadres />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Cotizaciones",
    key: "cotizaciones",
    programa: "cotizaciones",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/cotizaciones",
    component: <Cotizaciones />,
  },

  {
    type: "collapse",
    name: "Préstamos",
    key: "prestamos",
    programa: "prestamos",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/prestamos/gestion",
    component: "",
    collapse: [
      // "Expediente del Préstamo" ya no va en el menú: se llega haciendo
      // clic en un préstamo del informe (pantalla Préstamos).
      {
        name: "Expediente (ruta vieja)",
        key: "expediente-legacy",
        route: "/prestamos/expediente",
        component: <Expediente />,
      },
      // Expediente del Cliente: la vista 360 por persona (todos sus
      // préstamos, compras, pagos y cotizaciones). Comparte el permiso del
      // expediente del préstamo — sin siembra nueva en rolesusuarios.
      {
        type: "collapse",
        name: "Expediente del Cliente",
        key: "expedientecliente",
        programa: "expediente",
        route: "/clientes",
        component: <Clientes />,
      },
      {
        type: "collapse",
        name: "Gestión de Préstamos",
        key: "informeprestamos",
        keys: [
          "informeprestamos",
          "cancelacionprestamos",
          "ares3040",
          "ares3050",
          "listarcanceladosporfechas",
          "beneficiorecuperado",
          "expediente",
        ],
        route: "/prestamos/gestion",
        component: <PrestamosUnificado />,
      },
      // Rutas ocultas de compatibilidad hacia la pantalla unificada.
      {
        name: "Préstamos (informe)",
        key: "informeprestamos-legacy",
        route: "/prestamos/informeprestamos",
        component: <PrestamosUnificado />,
      },
      {
        name: "Préstamos (cancelados por fechas)",
        key: "listarcanceladosporfechas-legacy",
        route: "/prestamos/listarcanceladosporfechas",
        component: <PrestamosUnificado />,
      },
      {
        name: "Préstamos (cancelar)",
        key: "cancelacionprestamos-legacy",
        route: "/prestamos/cancelacionprestamos",
        component: <PrestamosUnificado />,
      },
      {
        name: "Préstamos (balance)",
        key: "ares3040-legacy",
        route: "/prestamos/balanceprestamos",
        component: <PrestamosUnificado />,
      },
      {
        name: "Préstamos (saldados)",
        key: "ares3050-legacy",
        route: "/prestamos/prestamossaldados",
        component: <PrestamosUnificado />,
      },
      // Gestión de cobros: promesas de pago y efectividad por gestor. El
      // mismo programa gobierna la pestaña Gestión del expediente.
      {
        type: "collapse",
        name: "Gestión de Cobros",
        key: "gestioncobros",
        route: "/prestamos/gestioncobros",
        component: <GestionCobros />,
      },
      // Pantallas movidas desde Facturación: conservan su URL vieja como
      // ruta oculta de compatibilidad justo debajo de cada una.
      {
        type: "collapse",
        name: "Modificación Préstamos",
        key: "ares2040",
        route: "/prestamos/modificacionprestamos",
        component: <ModificacionPrestamos />,
      },
      {
        name: "Modificación Préstamos (ruta vieja)",
        key: "ares2040-legacy",
        route: "/facturacion/modificacionprestamos",
        component: <ModificacionPrestamos />,
      },
      {
        type: "collapse",
        name: "Refinanciamientos",
        key: "ares2050",
        keys: ["ares2050", "ares2060"],
        route: "/prestamos/refinanciamientos",
        component: <Refinanciamientos />,
      },
      {
        name: "Refinanciamientos (ruta vieja)",
        key: "ares2050-facturacion-legacy",
        route: "/facturacion/refinanciamientos",
        component: <Refinanciamientos />,
      },
      {
        name: "Refinanciamientos (interno)",
        key: "ares2050-legacy",
        route: "/facturacion/refinanciamientointerno",
        component: <Refinanciamientos />,
      },
      {
        name: "Refinanciamientos (externo)",
        key: "ares2060-legacy",
        route: "/facturacion/refinanciamientoexterno",
        component: <Refinanciamientos />,
      },
      {
        type: "collapse",
        name: "Préstamos Personales",
        key: "ares2010ns",
        route: "/prestamos/prestamospersonales",
        component: <PrestamosPersonales />,
      },
      {
        name: "Préstamos Personales (ruta vieja)",
        key: "ares2010ns-legacy",
        route: "/facturacion/prestamospersonales",
        component: <PrestamosPersonales />,
      },
      {
        type: "collapse",
        name: "Calculadora",
        key: "calculadoraprestamos",
        route: "/prestamos/calculadoraprestamos",
        component: <CalculadoraPrestamos />,
      },

      { type: "subheader", name: "Reportes", key: "prestamos-reportes-sub" },
      {
        type: "collapse",
        name: "Morosidad",
        key: "reportemorosidad",
        route: "/prestamos/reportemorosidad",
        component: <ReporteMorosidad />,
      },
      {
        type: "collapse",
        name: "Reporte a Equifax",
        key: "reporteequifax",
        // Sin programa propio: lo ve quien tiene Morosidad o DataOrbit (el
        // backend exige además acceso a todas las sucursales).
        keys: ["reportemorosidad", "dataorbit"],
        route: "/prestamos/reporteequifax",
        component: <ReporteEquifax />,
      },
      {
        type: "collapse",
        name: "Antigüedad de Saldo",
        key: "antiguedaddesaldo",
        route: "/prestamos/antiguedaddesaldo",
        component: <ReporteAntiguedadSaldo />,
      },
      {
        type: "collapse",
        name: "Descuentos",
        key: "descuentosprestamos",
        route: "/prestamos/descuentosprestamos",
        component: <ReporteDescuentos />,
      },
      {
        type: "collapse",
        name: "Estados de Cuenta",
        key: "ares7010",
        route: "/prestamos/estadosdecuenta",
        component: <EstadosDeCuenta />,
      },
      {
        type: "collapse",
        name: "Crediticio",
        key: "ares7040",
        route: "/prestamos/reportecrediticio",
        component: <ReporteCrediticio />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Pagos",
    key: "pagos",
    programa: "pagos",
    icon: <Icon fontSize="small">receipt_long</Icon>,
    route: "/pagos/auditoriarecibos",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Pagos",
        key: "ares4010",
        keys: ["ares4010", "ares4015", "ares4030", "informepagos", "informepagoscancelados"],
        route: "/pagos/gestion",
        component: <Pagos />,
      },
      {
        type: "collapse",
        name: "Auditoria Recibos",
        key: "auditoriarecibos",
        route: "/pagos/auditoriarecibos",
        component: <Auditoriarecibos />,
      },
      // Rutas ocultas de compatibilidad: las URLs viejas de cobro/mantenimiento/
      // informes de pagos llevan a la pantalla unificada (sin `type` no salen
      // en el menú). El cobro especial se fusionó en el cobro normal (la fecha
      // editable aparece con el permiso ares4015).
      {
        name: "Pagos (cobro)",
        key: "ares4010-legacy",
        route: "/pagos/cobropagos",
        component: <Pagos />,
      },
      {
        name: "Pagos (cobro especial)",
        key: "ares4015-legacy",
        route: "/pagos/cobropagosespecial",
        component: <Pagos />,
      },
      {
        name: "Pagos (mantenimiento)",
        key: "ares4030-legacy",
        route: "/pagos/mantenimientopagos",
        component: <Pagos />,
      },
      {
        name: "Pagos (informe)",
        key: "informepagos-legacy",
        route: "/pagos/informepagos",
        component: <Pagos />,
      },
      {
        name: "Pagos (cancelados)",
        key: "informepagoscancelados-legacy",
        route: "/pagos/informepagoscancelados",
        component: <Pagos />,
      },

      { type: "subheader", name: "Reportes", key: "pagos-reportes-sub" },
      {
        type: "collapse",
        name: "Interes Cobrado Periodo",
        key: "intresescobradosperiodos",
        route: "/pagos/interescobradosperiodos",
        component: <Interescobradoperiodo />,
      },
      {
        type: "collapse",
        name: "Proyectado Cobros",
        key: "proyectadocobros",
        route: "/pagos/proyectadocobros",
        component: <Proyectadocobros />,
      },
      {
        type: "collapse",
        name: "Pagos Anteriores 1ra Cuota",
        key: "pagosanteriores1rcuota",
        route: "/pagos/pagosanteriores1rcuota",
        component: <Pagosantcuota />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Ventas Generales",
    key: "ventasgenerales",
    programa: "ventasgenerales",
    icon: <Icon fontSize="small">sell</Icon>,
    route: "/ventasgenerales/ventas",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Ventas",
        key: "ares9620",
        keys: ["ares9620", "ares9610", "ares9630"],
        route: "/ventasgenerales/ventas",
        component: <VentasGeneralesUnificado />,
      },
      {
        type: "collapse",
        name: "Pagos",
        key: "ares9640",
        keys: ["ares9640", "ares9650"],
        route: "/ventasgenerales/pagos",
        component: <PagosVentasUnificado />,
      },
      // Rutas ocultas de compatibilidad: las URLs viejas del módulo llevan a
      // las pantallas unificadas (sin `type` no salen en el menú).
      {
        name: "Ventas generales (registrar)",
        key: "ares9610-legacy",
        route: "/ventasgenerales/registrarventageneral",
        component: <VentasGeneralesUnificado />,
      },
      {
        name: "Ventas generales (mantenimiento)",
        key: "ares9620-legacy",
        route: "/ventasgenerales/mantenimientoventasgenerales",
        component: <VentasGeneralesUnificado />,
      },
      {
        name: "Ventas generales (reportes)",
        key: "ares9630-legacy",
        route: "/ventasgenerales/reportesventasgenerales",
        component: <VentasGeneralesUnificado />,
      },
      {
        name: "Pagos ventas (cobrar)",
        key: "ares9650-legacy",
        route: "/ventasgenerales/pagosventasgenerales",
        component: <PagosVentasUnificado />,
      },
      {
        name: "Pagos ventas (mantenimiento)",
        key: "ares9640-legacy",
        route: "/ventasgenerales/mantenimientopagosventas",
        component: <PagosVentasUnificado />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Ventas x Mayor",
    key: "ventaspormayor",
    programa: "ventaspormayor",
    icon: <Icon fontSize="small">local_shipping</Icon>,
    route: "/ventasxmayor/facturas",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Facturas",
        key: "ares9720",
        keys: ["ares9720", "ares9710", "ares9756", "ares9755"],
        route: "/ventasxmayor/facturas",
        component: <XmayorFacturas />,
      },
      {
        // Segmento propio: todo lo consignado del módulo (conduces de entrega,
        // marcado de lo vendido, sus facturas, y las facturas consignadas del
        // modelo anterior).
        type: "collapse",
        name: "Consignaciones",
        key: "conducesxmayor",
        route: "/ventasxmayor/consignaciones",
        component: <XmayorConsignaciones />,
      },
      {
        type: "collapse",
        name: "Cobros",
        key: "ares9740",
        keys: ["ares9740", "ares9715", "ares9750"],
        route: "/ventasxmayor/cobros",
        component: <XmayorCobros />,
      },
      {
        type: "collapse",
        name: "Clientes",
        key: "ares9705",
        keys: ["ares9705", "ares9730", "ares9725"],
        route: "/ventasxmayor/clientes",
        component: <XmayorClientes />,
      },
      // Rutas ocultas de compatibilidad: las URLs viejas del módulo llevan a
      // las pantallas unificadas (sin `type` no salen en el menú).
      {
        name: "xMayor (clientes)",
        key: "ares9705-legacy",
        route: "/ventasxmayor/clientesxmayor",
        component: <XmayorClientes />,
      },
      {
        name: "xMayor (facturar)",
        key: "ares9710-legacy",
        route: "/ventasxmayor/facturarxmayor",
        component: <XmayorFacturas />,
      },
      {
        name: "xMayor (cobrar)",
        key: "ares9715-legacy",
        route: "/ventasxmayor/cobrosxmayor",
        component: <XmayorCobros />,
      },
      {
        name: "xMayor (mant. facturas)",
        key: "ares9720-legacy",
        route: "/ventasxmayor/mantenimientofacturasxmayor",
        component: <XmayorFacturas />,
      },
      {
        name: "xMayor (mant. cobros)",
        key: "ares9740-legacy",
        route: "/ventasxmayor/mantenimientocobrosxmayor",
        component: <XmayorCobros />,
      },
      {
        name: "xMayor (precio motor)",
        key: "ares9756-legacy",
        route: "/ventasxmayor/modificarpreciomotor",
        component: <XmayorFacturas />,
      },
      {
        name: "xMayor (antigüedad)",
        key: "ares9725-legacy",
        route: "/ventasxmayor/antiguedadsaldoxmayor",
        component: <XmayorClientes />,
      },
      {
        name: "xMayor (estado de cuenta)",
        key: "ares9730-legacy",
        route: "/ventasxmayor/estadocuentaxmayor",
        component: <XmayorClientes />,
      },
      {
        name: "xMayor (listado cobros)",
        key: "ares9750-legacy",
        route: "/ventasxmayor/listadocobrosxmayor",
        component: <XmayorCobros />,
      },
      {
        name: "xMayor (chasis vendidos)",
        key: "ares9755-legacy",
        route: "/ventasxmayor/chasisvendidosxmayor",
        component: <XmayorFacturas />,
      },
      {
        name: "xMayor (conduces consignados)",
        key: "conducesxmayor-legacy",
        route: "/ventasxmayor/conduces",
        component: <XmayorConsignaciones />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Matrículas",
    key: "matriculas",
    programa: "matriculas",
    icon: <Icon fontSize="small">badge</Icon>,
    route: "/matriculas/cobros",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Cobros de Matrícula",
        key: "ares6010",
        keys: ["ares6010", "ares6040", "ares6020"],
        route: "/matriculas/cobros",
        component: <MatriculasCobros />,
      },
      {
        type: "collapse",
        name: "Traspasos",
        key: "ares6030",
        keys: ["ares6030", "ares6060", "traspaso"],
        route: "/matriculas/traspasos",
        component: <Traspasos />,
      },
      {
        type: "collapse",
        name: "Solicitudes DGII/Proveedor",
        key: "solicitudmatriculas",
        route: "/matriculas/solicitudes",
        component: <Solicitudes />,
      },
      {
        // Las sucursales piden a la central matrícula/placa/copias de lo que
        // vendieron; con el flag modificar, la bandeja de la central.
        type: "collapse",
        name: "Pedidos a la Central",
        key: "pedidomatriculas",
        route: "/matriculas/pedidos",
        component: <PedidosMatricula />,
      },
      {
        type: "collapse",
        name: "Recibir Matriculas DGII",
        key: "ares6050",
        route: "/matriculas/recibirdgii",
        component: <RecibirMatriculaDgii />,
      },
      // Rutas ocultas de compatibilidad: las URLs viejas del módulo llevan a
      // las pantallas unificadas (sin `type` no salen en el menú).
      {
        name: "Matrículas (cobro)",
        key: "ares6010-legacy",
        route: "/matriculas/cobromatricula",
        component: <MatriculasCobros />,
      },
      {
        name: "Matrículas (listado cobros)",
        key: "ares6020-legacy",
        route: "/matriculas/listadocobros",
        component: <MatriculasCobros />,
      },
      {
        name: "Matrículas (cancelar cobro)",
        key: "ares6040-legacy",
        route: "/matriculas/cancelarcobro",
        component: <MatriculasCobros />,
      },
      {
        name: "Traspasos (traspasar)",
        key: "ares6030-legacy",
        route: "/matriculas/traspasarmatricula",
        component: <Traspasos />,
      },
      {
        name: "Traspasos (mantenimiento)",
        key: "ares6060-legacy",
        route: "/matriculas/cancelartraspaso",
        component: <Traspasos />,
      },
    ],
  },

  { type: "title", title: "Inventario y Logística", key: "seccion-inventario-logistica" },

  {
    type: "collapse",
    name: "Inventario",
    key: "inventario",
    programa: "inventario",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/inventario",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Registro de Chasis",
        key: "ares1010",
        route: "/inventario/registrochasis",
        component: <RegistroChasis />,
      },
      {
        type: "collapse",
        name: "Informe Motores",
        key: "informemotores",
        route: "/inventario/informemotores",
        component: <InformeMotores />,
      },
      {
        // Módulo de conteos multi-usuario. `keys`: el programa nuevo es
        // "conteos", pero los roles existentes solo tienen la fila de la
        // pantalla vieja; cualquiera de los dos da acceso mientras se
        // siembra el nuevo (actualizaciones/sembrar_programa_conteos.py
        // en el server).
        type: "collapse",
        name: "Conteos de Inventario",
        key: "conteos",
        keys: ["conteos", "conteoinventariosucursal"],
        route: "/inventario/conteos",
        component: <Conteos />,
      },
      {
        // Pantalla de escaneo de un conteo abierto (?id=N); se llega desde
        // la lista, no desde el menú.
        name: "Conteo activo",
        key: "conteos-activo",
        route: "/inventario/conteos/activo",
        component: <ConteoActivo />,
      },
      {
        // Reporte de conteos (exactitud, participantes, situación actual por
        // chasis); se llega desde la lista. Elegir sucursal requiere el flag
        // versucursal de conteos: el backend fuerza la propia sin él.
        name: "Reporte de conteos",
        key: "conteos-reporte",
        route: "/inventario/conteos/reporte",
        component: <ReporteConteos />,
      },
      {
        // Ruta vieja de la pantalla de conteo único: lleva a la lista.
        name: "Conteo por Sucursal",
        key: "conteoinventariosucursal-legacy",
        route: "/inventario/conteoinventariosucursal",
        component: <Conteos />,
      },
      {
        // Estandarización de marcas y modelos: catálogo canónico, variantes
        // de escritura detectadas en los datos vivos y fusión hacia la
        // entrada canónica. `keys`: mientras se siembra el programa nuevo
        // en los tenants, la fila de "configuracion" da acceso (mismo
        // criterio transitorio que conteos; catalogoProgramas no registra
        // la key prestada en este módulo).
        type: "collapse",
        name: "Marcas y Modelos",
        key: "marcasmodelos",
        keys: ["marcasmodelos", "configuracion"],
        route: "/inventario/marcasmodelos",
        component: <MarcasModelos />,
      },

      {
        type: "collapse",
        name: "Historial Chasis",
        key: "historialchasis",
        route: "/inventario/historialchasis",
        component: <HistorialChasis />,
      },

      {
        type: "collapse",
        name: "Transferencias Chasis",
        key: "transferenciachasis",
        route: "/inventario/transferenciachasis",
        component: <Transferenciaschasis />,
      },
      // "Cobros Incautos Fechas" se movió al módulo Incautos (su dominio real);
      // la URL vieja vive allá como ruta oculta de compatibilidad.
      // "InformeTraspaso" se movió a Matrículas → Traspasos.
      {
        name: "Traspasos (informe, ruta vieja)",
        key: "traspaso-legacy",
        route: "/inventario/traspaso",
        component: <Traspasos />,
      },
      {
        type: "collapse",
        name: "Inventario Documentos",
        key: "inventariomatriculas",
        route: "/inventario/inventariodocumentos",
        component: <Transferenciadocumentos />,
      },
      {
        type: "collapse",
        name: "Consignaciones",
        key: "consignaciones",
        route: "/inventario/consignaciones",
        component: <Consignaciones />,
      },
      // Rutas ocultas de compatibilidad hacia la pantalla unificada.
      {
        name: "Consignaciones (liquidación)",
        key: "consignaciones-liq-legacy",
        route: "/inventario/liquidacionconsignaciones",
        component: <Consignaciones />,
      },
      {
        name: "Consignaciones (reporte)",
        key: "consignaciones-rep-legacy",
        route: "/inventario/reporteconsignaciones",
        component: <Consignaciones />,
      },
      {
        name: "Consignaciones (estado de cuenta)",
        key: "consignaciones-edo-legacy",
        route: "/inventario/estadocuentaconsignante",
        component: <Consignaciones />,
      },
    ],
  },

  {
    // Embarques de importación (contenedores desde fábrica). El programa es
    // "importaciones" — no confundir con "importaciondatos" (importador de
    // Excel, en Herramientas).
    type: "collapse",
    name: "Importaciones",
    key: "importaciones",
    programa: "importaciones",
    icon: <Icon fontSize="small">directions_boat</Icon>,
    route: "/importaciones/embarques",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Embarques",
        key: "importaciones-embarques",
        programa: "importaciones",
        route: "/importaciones/embarques",
        component: <Embarques />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Taller",
    key: "taller",
    programa: "taller",
    icon: <Icon fontSize="small">build</Icon>,
    route: "/taller/ordenes",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Órdenes de Taller",
        key: "ares9015",
        keys: ["ares9015", "ares9010", "ares9020", "ares9025"],
        route: "/taller/ordenes",
        component: <OrdenesTaller />,
      },
      // Rutas ocultas de compatibilidad hacia la pantalla unificada.
      {
        name: "Taller (recepción)",
        key: "ares9010-legacy",
        route: "/taller/entradataller",
        component: <OrdenesTaller />,
      },
      {
        name: "Taller (salida)",
        key: "ares9020-legacy",
        route: "/taller/salidataller",
        component: <OrdenesTaller />,
      },
      {
        name: "Taller (eventos)",
        key: "ares9015-legacy",
        route: "/taller/eventostaller",
        component: <OrdenesTaller />,
      },
      {
        name: "Taller (reporte)",
        key: "ares9025-legacy",
        route: "/taller/reportetaller",
        component: <OrdenesTaller />,
      },
    ],
  },

  {
    // Garantía postventa y calendario de mantenimientos (requiere
    // varinicial.usagarantias; la pantalla avisa si está apagada).
    // `keys`: mientras se siembra el programa nuevo, la fila de "taller" da
    // acceso (mismo criterio transitorio que conteos y marcasmodelos).
    type: "collapse",
    name: "Garantías",
    key: "garantias",
    keys: ["garantias", "taller"],
    icon: <Icon fontSize="small">verified</Icon>,
    route: "/garantias",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Garantías y Mantenimientos",
        key: "garantias-consulta",
        programa: "garantias",
        keys: ["garantias", "taller"],
        route: "/garantias",
        component: <Garantias />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Incautos",
    key: "incautos",
    programa: "incautos",
    icon: <Icon fontSize="small">no_crash</Icon>,
    route: "/incautos/registrarincauto",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Incautos y Cargos",
        key: "ares5080",
        keys: ["ares5080", "ares5010", "ares5060", "ares5095", "ares8070"],
        route: "/incautos/gestion",
        component: <Incautos />,
      },
      {
        type: "collapse",
        name: "Solicitudes de Incauto",
        key: "ares5030",
        keys: ["ares5030", "ares5010"],
        route: "/incautos/solicitudes",
        component: <SolicitudesIncauto />,
      },
      {
        type: "collapse",
        name: "Pagos a Incautadores",
        key: "ares5085",
        keys: ["ares5085", "ares5090"],
        route: "/incautos/pagos",
        component: <PagosIncautadoresUnificado />,
      },
      // Movida desde Inventario: los cobros de incautos por fechas pertenecen
      // a este dominio. La URL vieja se conserva como ruta oculta.
      {
        type: "collapse",
        name: "Cobros Incautos Fechas",
        key: "cobrosincautosfechas",
        route: "/incautos/cobrosincautosfechas",
        component: <Cobrosincautosfechas />,
      },
      {
        name: "Cobros Incautos Fechas (ruta vieja)",
        key: "cobrosincautosfechas-legacy",
        route: "/inventario/cobrosincautosfechas",
        component: <Cobrosincautosfechas />,
      },
      // Rutas ocultas de compatibilidad: las URLs viejas del módulo llevan a
      // las pantallas unificadas (sin `type` no salen en el menú).
      {
        name: "Incautos (registrar)",
        key: "ares5010-legacy",
        route: "/incautos/registrarincauto",
        component: <Incautos />,
      },
      {
        name: "Incautos (cargo)",
        key: "ares5060-legacy",
        route: "/incautos/registrarcargo",
        component: <Incautos />,
      },
      {
        name: "Incautos (mantenimiento)",
        key: "ares5080-legacy",
        route: "/incautos/mantenimientoincautos",
        component: <Incautos />,
      },
      {
        name: "Incautos (informe cargos)",
        key: "ares5095-legacy",
        route: "/incautos/informecargos",
        component: <Incautos />,
      },
      {
        name: "Incautos (modificar valor, ruta vieja)",
        key: "ares8070-legacy",
        route: "/configuracion/modificarincautocargo",
        component: <Incautos />,
      },
      {
        name: "Pagos incautadores (pagar)",
        key: "ares5085-legacy",
        route: "/incautos/pagosincautadores",
        component: <PagosIncautadoresUnificado />,
      },
      {
        name: "Pagos incautadores (listado)",
        key: "ares5090-legacy",
        route: "/incautos/listapagosincautadores",
        component: <PagosIncautadoresUnificado />,
      },
    ],
  },

  { type: "title", title: "Finanzas", key: "seccion-finanzas" },

  {
    type: "collapse",
    name: "Gastos",
    key: "gastos",
    programa: "gastos",
    icon: <Icon fontSize="small">money_off</Icon>,
    route: "/gastos/informegastos",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Gastos",
        key: "informegastos",
        // Los programas reales de rolesusuarios son los ares55xx (5510
        // registrar, 5520 mantenimiento, 5530 listado); se mantienen los
        // nombres web por compatibilidad con tenants que los usen.
        keys: ["ares5530", "ares5510", "ares5520", "informegastos", "agregargasto"],
        route: "/gastos/informegastos",
        component: <Informegastos />,
      },
      {
        name: "Gastos (agregar)",
        key: "agregargasto-legacy",
        route: "/gastos/agregar",
        component: <Informegastos />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Cuentas x Pagar",
    key: "cuentasxpagar",
    programa: "cuentasxpagar",
    icon: <Icon fontSize="small">request_quote</Icon>,
    route: "/cuentasxpagar/facturas",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Facturas",
        key: "ares8520",
        keys: ["ares8520", "ares8510", "ares8550"],
        route: "/cuentasxpagar/facturas",
        component: <CxpFacturas />,
      },
      {
        type: "collapse",
        name: "Pagos",
        key: "ares8540",
        keys: ["ares8540", "ares8515"],
        route: "/cuentasxpagar/pagos",
        component: <CxpPagos />,
      },
      {
        type: "collapse",
        name: "Suplidores",
        key: "ares8505",
        keys: ["ares8505", "ares8535", "ares8530"],
        route: "/cuentasxpagar/suplidores",
        component: <CxpSuplidores />,
      },
      // Rutas ocultas de compatibilidad: las URLs viejas del módulo llevan a
      // las pantallas unificadas (sin `type` no salen en el menú).
      {
        name: "CXP (suplidores)",
        key: "ares8505-legacy",
        route: "/cuentasxpagar/suplidorescxp",
        component: <CxpSuplidores />,
      },
      {
        name: "CXP (factura general)",
        key: "ares8510-legacy",
        route: "/cuentasxpagar/facturageneralcxp",
        component: <CxpFacturas />,
      },
      {
        name: "CXP (pagar)",
        key: "ares8515-legacy",
        route: "/cuentasxpagar/pagoscxp",
        component: <CxpPagos />,
      },
      {
        name: "CXP (mant. facturas)",
        key: "ares8520-legacy",
        route: "/cuentasxpagar/mantenimientofacturascxp",
        component: <CxpFacturas />,
      },
      {
        name: "CXP (mant. pagos)",
        key: "ares8540-legacy",
        route: "/cuentasxpagar/mantenimientopagoscxp",
        component: <CxpPagos />,
      },
      {
        name: "CXP (chasis factura)",
        key: "ares8550-legacy",
        route: "/cuentasxpagar/chasisfacturacxp",
        component: <CxpFacturas />,
      },
      {
        name: "CXP (antigüedad)",
        key: "ares8530-legacy",
        route: "/cuentasxpagar/antiguedadsaldocxp",
        component: <CxpSuplidores />,
      },
      {
        name: "CXP (estado de cuenta)",
        key: "ares8535-legacy",
        route: "/cuentasxpagar/estadocuentasuplidor",
        component: <CxpSuplidores />,
      },
    ],
  },

  // Clientes/Suplidores se retiró de este menú; la pantalla sigue viva en la
  // app de Facturación (véase `routesfac.js`). Su programa se mantiene en el
  // catálogo de roles vía COMPLEMENTO, porque este archivo lo alimenta.

  { type: "title", title: "Herramientas", key: "seccion-herramientas" },

  // Importación se movió desde Préstamos: son utilitarios de datos, no
  // operación de préstamos.
  {
    type: "collapse",
    name: "Importación",
    key: "importacion",
    programa: "importaciondatos",
    icon: <Icon fontSize="small">upload_file</Icon>,
    route: "/importacion/importaciondatos",
    component: "",
    collapse: [
      {
        type: "collapse",
        name: "Importacion de Datos",
        key: "importaciondatos",
        route: "/importacion/importaciondatos",
        component: <ImportacionDatos />,
      },
      {
        type: "collapse",
        name: "Importar Ventas x Mayor",
        key: "importarventasxmayor",
        // Comparte permiso con "Importacion de Datos": quien puede importar
        // datos tambien ve la importacion de ventas x mayor.
        programa: "importaciondatos",
        route: "/importacion/ventasxmayor",
        component: <ImportarXmayor />,
      },
      {
        type: "collapse",
        name: "Importar Conduces x Mayor",
        key: "importarconducesxmayor",
        // Comparte permiso con "Importacion de Datos", igual que la
        // importacion de ventas x mayor.
        programa: "importaciondatos",
        route: "/importacion/conducesxmayor",
        component: <ImportarConducesXmayor />,
      },
      {
        type: "collapse",
        name: "Importar Ventas al Contado",
        key: "importarventascontado",
        // Comparte permiso con "Importacion de Datos", igual que las
        // importaciones x mayor.
        programa: "importaciondatos",
        route: "/importacion/ventascontado",
        component: <ImportarVentasContado />,
      },
    ],
  },

  {
    type: "collapse",
    name: "DataOrbit",
    key: "dataorbit",
    programa: "dataorbit",
    icon: <Icon fontSize="small">hub</Icon>,
    route: "/dataorbit",
    component: <DataOrbit />,
  },

  // Bitácora del sistema: consulta del registro de acciones (app/auditoria
  // del backend). Programa propio `bitacora` — siembra pendiente en
  // rolesusuarios al desplegar, como todo programa nuevo.
  {
    type: "collapse",
    name: "Bitácora",
    key: "bitacora",
    programa: "bitacora",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/herramientas/bitacora",
    component: <Bitacora />,
  },

  // Documentación se movió DENTRO de Configuración (tarjeta en ConfiguracionHub).
  // Se conserva la URL como ruta oculta de compatibilidad (sin `type`, no sale
  // en el menú); el acceso vive en el hub de Configuración.
  {
    name: "Configuración (documentación)",
    key: "documentacion-legacy",
    route: "/documentacion/documentos",
    component: <Documentos />,
  },

  // Configuración vive al final del menú, separada de los módulos operativos
  // (adminZone pinta el divisor y el estilo diferenciado en el Sidenav).
  {
    type: "collapse",
    name: "Configuración",
    key: "configuracion",
    keys: [
      "configuracion",
      "ares8060",
      "ares3030",
      "ares8080",
      "ares8090",
      "documentos",
      "documentacion",
      "monedas",
    ],
    adminZone: true,
    icon: <Icon fontSize="small">settings</Icon>,
    route: "/configuracion",
    component: <ConfiguracionHub />,
  },
  // Rutas ocultas de compatibilidad: las URLs viejas del grupo llevan al hub.
  {
    name: "Configuración (sistema)",
    key: "configuracion-sistema-legacy",
    route: "/configuracion/sistema",
    component: <ConfiguracionHub />,
  },
  {
    name: "Configuración (catálogos)",
    key: "configuracion-catalogos-legacy",
    route: "/configuracion/catalogos",
    component: <ConfiguracionHub />,
  },
  {
    name: "Configuración (usuarios)",
    key: "configuracion-usuarios-legacy",
    route: "/configuracion/usuariosroles",
    component: <ConfiguracionHub />,
  },
  {
    name: "Configuración (abonos)",
    key: "ares8060-legacy",
    route: "/configuracion/abonoscapital",
    component: <ConfiguracionHub />,
  },
  {
    name: "Configuración (intereses)",
    key: "ares3030-legacy",
    route: "/configuracion/descuentosinteres",
    component: <ConfiguracionHub />,
  },
  {
    name: "Configuración (limpiar producto)",
    key: "ares8080-legacy",
    route: "/configuracion/limpiarproducto",
    component: <ConfiguracionHub />,
  },
  {
    name: "Configuración (cambio sucursal)",
    key: "ares8090-legacy",
    route: "/configuracion/cambiosucursalprestamo",
    component: <ConfiguracionHub />,
  },

  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/login",
    component: <Entrar />,
  },
  {
    name: "Sign Up",
    key: "sign-up",
    route: "/login",
    component: <Entrar />,
  },
];

export default routes;
